export default {
  currentPassword: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  newPassword: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  confirmation: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/myaccount/profile/profile-form.js